var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDataReady)?_c('ul',{staticClass:"menu-nav pt-10 mt-10"},_vm._l((_vm.menus),function(menu){return _c('div',{key:menu.title},[(menu.type === 'default')?_c('navi-compact',{attrs:{"item":menu}}):_c('navi-drop-down',{attrs:{"item":menu}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }